/**
 * @ngInject
 */

function freezeBody () {

	function onFreezeTriggerOn () {
		
		var scrollbarWidth = window.innerWidth - document.body.offsetWidth;

		document.body.style.maxHeight = '100vh';
		document.body.style.overflow = 'hidden';
		document.body.style.paddingRight = scrollbarWidth+'px';

	}

	function onFreezeTriggerOff () {
		document.body.style.maxHeight = 'none';
		document.body.style.overflow = 'visible';
		document.body.style.paddingRight = '0px';
	}

	function link (scope, elem, attrs) {

		elem[0].addEventListener(attrs.triggerOn, onFreezeTriggerOn);
		elem[0].addEventListener(attrs.triggerOff, onFreezeTriggerOff);
	}

	return {
		restrict : 'A',
		link : link,
	}
}